import bootstrapBrowser from './engines/browser';
import bootstrapCordova from './engines/cordova';
import { determineEngine, Engine } from './engine';

/**
 * Returns a promise that resolves after all the bootstrap and init steps for
 * the given engine has been completed.
 *
 * @param  {Engine} engine
 * @return {Promise<void>}
 */
function engineDynamicSteps(engine) {
    if (engine === Engine.BROWSER) {
        return bootstrapBrowser();
    } else if (engine === Engine.CORDOVA) {
        return bootstrapCordova();
    } else {
        return Promise.reject(`Can't determine steps for ${engine}`)
    }
}

/**
 * Returns a promise that resolves after the bootstrap configuration
 * steps for the engine currently running the script have completed.
 *
 * @return {Promise<void>}
 */
export function bootstrapEngine() {
    return Promise.resolve(determineEngine())
    .then((engine) => engineDynamicSteps(engine))
    .then(() => {})
}



// WEBPACK FOOTER //
// ./src/shared/engine-dynamic/bootstrap.js